import React from 'react';

export const parseText = (text) => {
    if (!text) return null;

    // Array to store the final result
    const result = [];
    let currentIndex = 0;

    // Regular expressions for matching patterns
    const boldRegex = /\*\*(.*?)\*\*/g;
    const linkRegex = /\[(.*?)\]\((.*?)\)/g;

    // Keep track of matches and their positions
    let matches = [];
    
    // Find all bold text matches
    let boldMatch;
    while ((boldMatch = boldRegex.exec(text)) !== null) {
        matches.push({
            type: 'bold',
            start: boldMatch.index,
            end: boldMatch.index + boldMatch[0].length,
            content: boldMatch[1],
            fullMatch: boldMatch[0]
        });
    }

    // Find all link matches
    let linkMatch;
    while ((linkMatch = linkRegex.exec(text)) !== null) {
        matches.push({
            type: 'link',
            start: linkMatch.index,
            end: linkMatch.index + linkMatch[0].length,
            text: linkMatch[1],
            url: linkMatch[2],
            fullMatch: linkMatch[0]
        });
    }

    // Sort matches by their start position
    matches.sort((a, b) => a.start - b.start);

    // Process the text with matches
    matches.forEach((match, index) => {
        // Add text before the match
        if (match.start > currentIndex) {
            result.push(text.substring(currentIndex, match.start));
        }

        // Add the matched element
        if (match.type === 'bold') {
            result.push(<strong key={`bold-${index}`}>{match.content}</strong>);
        } else if (match.type === 'link') {
            result.push(
                <a 
                    key={`link-${index}`}
                    href={match.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="about-link"
                >
                    {match.text}
                </a>
            );
        }

        currentIndex = match.end;
    });

    // Add any remaining text
    if (currentIndex < text.length) {
        result.push(text.substring(currentIndex));
    }

    return result;
}; 